import React from "react";
import useIteraion from "../Hooks/useIntegraion";
import Footer from "../component/footer";
function IntegrationService() {
  const { onSubmit, fields, setFields } = useIteraion();

  return (
    <>
      <section className="section-banner">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-12">
              <h2>Integration</h2>
              <h3>Services</h3>
              <p>
                Our Development team will guide you in the integration process.
                Gaming Arcade will provide a professional team to perform game
                and gamification platform integration into your Mobile App or
                Website.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="custom-content">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-4">
              <div className="custom-body">
                <h1>Customized Games</h1>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s,
                </p>
              </div>
              <div className="custom-body">
                <h1>Daily Visits</h1>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s,
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="img-body">
                <img src={require(".././Assets/img/mobile-new.png")} alt="" />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="custom-body">
                <h1>Prizes & Rewards</h1>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s,
                </p>
              </div>
              <div className="custom-body">
                <h1>Team & Support</h1>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s,
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="explore-games play-earn next-gen">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-6">
              <h1>Powering</h1>
              <h2>
                The Next Generation <span>Of Players</span>
              </h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book
              </p>
            </div>
            <div className="col-lg-6">
              <img
                src={require(".././Assets/img/arcade-side.png")}
                alt="icon"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="contactc-info">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-12">
              <h1>Contact Us if your interest in build a Web 3 Game</h1>
              {/* <div className="col-lg-3">
                    <Button value="Contact Us" />
                    </div> */}
            </div>
          </div>
        </div>
      </section>
      <section className="explore-games play-earn next-gen">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-6">
              <h2>
                <span>Fully Integerated </span>
                <br /> Marketplace
              </h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book
              </p>
            </div>
            <div className="col-lg-6">
              <img src={require(".././Assets/img/board.png")} alt="icon" />
            </div>
          </div>
        </div>
      </section>
      <section className="explore-games play-earn">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-6 crpto">
              <img
                src={require(".././Assets/img/intelligence.png")}
                alt="icon"
              />
            </div>
            <div className="col-lg-6 ">
              <h2>
                <span>Intelligence</span>
                <br />
                Suite
              </h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries,
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="explore-games play-earn next-gen">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-6">
              <h2>
                <span>Fully Integerated </span>
                <br /> Marketplace
              </h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book
              </p>
            </div>
            <div className="col-lg-6">
              <img src={require(".././Assets/img/token.png")} alt="icon" />
            </div>
          </div>
        </div>
      </section>
      <section className="explore-games play-earn">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-6 crpto">
              <img src={require(".././Assets/img/new.png")} alt="icon" />
            </div>
            <div className="col-lg-6 ">
              <h2>
                <span>Built-in</span>
                <br />
                Compliance
              </h2>

              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries,
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="home-sec-6">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-12">
              <h2>Our Partners</h2>
            </div>
            <div className="col-lg-12 partner-logo">
              <img src={require(".././Assets/img/market-watch.png")} alt="" />
              <img src={require(".././Assets/img/market-watch.png")} alt="" />
              <img src={require(".././Assets/img/NewsBTC.png")} alt="" />
              <img src={require(".././Assets/img/market-watch.png")} alt="" />
              <img src={require(".././Assets/img/market-watch.png")} alt="" />
            </div>
          </div>
        </div>
      </section>
      <section className="game-arcade-platform">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-6">
              <h3>
                Gaming Arcade <span>Platform</span> Functionalites
              </h3>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries,
              </p>
            </div>
            <div className="col-lg-6">
              <img src={require(".././Assets/img/laptop.png")} alt="" />
            </div>
          </div>
        </div>
      </section>
      <section className="game-arcade-platform">
        <div className="container-1280">
          <div className="col-lg-12">
            <h1>
              Contact <span>Us</span>
            </h1>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <form
                type="submit"
                onSubmit={(e) => {
                  onSubmit(e.preventDefault());
                }}
              >
                <input
                  type="text"
                  className="form-control"
                  placeholder="Your Name*"
                  required
                  onChange={(e) =>
                    setFields({ ...fields, name: e.target.value })
                  }
                  value={fields.name}
                />
                <input
                  type="email"
                  className="form-control"
                  placeholder="Your Email*"
                  required
                  onChange={(e) =>
                    setFields({ ...fields, email: e.target.value })
                  }
                  value={fields.email}
                />
                <textarea
                  className="form-control"
                  placeholder="Your Message*"
                  required
                  onChange={(e) =>
                    setFields({ ...fields, message: e.target.value })
                  }
                  value={fields.message}
                />
                <button className="btn btn-primary" type="submit">
                  Submit
                </button>
              </form>
            </div>
            <div className="col-lg-6">
              <img src={require(".././Assets/img/contact-robo.png")} alt="" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
export default IntegrationService;
